import debounce from 'lodash/debounce';

try { // Import webpack jQ
  window.$ = window.jQuery = require('jquery')
} catch (e) {}

// Libs
require('./jquery.touchSwipe.min.js')
require('./masonry.pkgd.min.js')
require('./select2.min.js')
require('./jquerydatepicker.min.js')
require ('./hyphenation');


$(function(){
  // Hack to get the REAL window size
  $('body, html').css('overflow', 'hidden').css('overflow', 'visible')
})

require('./escaper')
require('./header')
require('./filters')
require('./expands')
require('./archiveFilterExpands');
// require('./linkedinShareFix');
// require('./facebookShareFix');
// require('./twitterShareFix');

const {embedPlaceholderModifier} = require("./embedPlaceholderModifier");
const {youRamObserver} = require("./youRamObserver");
//const {sliderNavFix} = require('./sliderNavFix');

// require('./embedPlaceholderModifier');

$(document).ready(() => {
  embedPlaceholderModifier();
  youRamObserver();
 // sliderNavFix();
});

// Smaller functions

$(function(){

  /** Archive Search Interface */

  $(document).ready(function() {

    var ArchiveSearch = new function () {
      var self = this

      /**
       * Object to hold current state of search page filters values
       * key - filter name
       * val - filter value (string|array)
       * @type {Object}
       */
      self.filterState = {}

      // DOM element to display results in
      self.resultsContainer = {}
      self.noResultsNotice  = {}
      self.loadMoreBtn      = {}
      self.paginationBtn    = {}

      let pathName = common_utility_var.pathName !== undefined && common_utility_var.pathName !== null && common_utility_var.pathName !== '' ? '/' + common_utility_var.pathName : '';

      /**
       * Custom WP REST API endpoint to handle results
       * @type {String}
       */
      self.apiUrl = pathName + '/wp-json/macs/v1/press_release_search_results';

      self.init = function () {

        // Get DOM elements
        self.resultsContainer = $('.filters-content')
        self.noResultsNotice  = $('.js-no-results')
        self.loadMoreBtn      = $('.filters-more')
        self.paginationContainer = $('.filters-pagination')
        self.paginationBtn    = $('.filters-pagination-btn')

        self.postType = self.resultsContainer.attr('data-type')

        // Return if no required DOM or API
        if (
            !self.resultsContainer.length ||
            !self.noResultsNotice.length ||
            ((self.postType !== 'employee-testimonial' && self.postType !== 'people' && self.postType !== 'research-topics' && self.postType !== 'research-authors') && !self.loadMoreBtn.length)
        ) {
          return
        }

        self.enableActivateButtons();

        self.setApiUrl()

        // Listen to filters changes in DOM
        // Every filter change will update the window.location hash
        self.bindFiltersChange()

        // initial state: fetch data based on params in window.location.hash
        self.loadInitialState()

        // Listen to window.location.hash changes
        // Every change will refresh search results
        window.onhashchange = function() { self.refreshResults() }

        // Additional DOM behaviour tweaks
        self.loadMoreBtn.off().on('click', function(e) {
          e.preventDefault()
        })
        self.paginationBtn.off().on('click', function(e) {
          e.preventDefault()
        })

        // Make sure to hide select2 dropdowns so they don't interfere with other js events
        $( window ).on('scroll', function() {
          $('.js-with-select2').select2('close')
        })
      }

      /**
       * Enable activate buttons.
       */
      self.enableActivateButtons = function() {

        // For now the tabs are available for events only.
        if ( 'event' === self.postType ) {

          // NOTE: This can be ignorable, we are not doing any database request based on it,
          //       We are just adding class to element based on it's value and we have added proper checks as well.
          let currentUrl = window.location.href; // phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment

          let queryString = currentUrl.substring( currentUrl.indexOf( '#' ) + 1 );

          let searchParams = new URLSearchParams( queryString );

          if ( searchParams.has( 'events' ) ) {

            let selectedEvents = searchParams.get( 'events' );

            if ( '' !== selectedEvents ) {

              self.enableTabButton( selectedEvents, 'disable-button' );
            }
          }

          if ( searchParams.has( 'events_type' ) ) {

            let eventTypes = searchParams.get( 'events_type' );

            let selectedEventTypes = eventTypes.split( '-' );

            if ( selectedEventTypes.length ) {

              for ( let i = 0; i < selectedEventTypes.length; i++ ) {

                self.enableTabButton( selectedEventTypes[i], 'selected-event-type' );
              }
            }
          }
        }
      }

      self.enableTabButton = function( selectedEvents, cssClass ) {

        let selectedElement = $( 'a[data-value="' + selectedEvents + '"]' );

        if ( selectedElement.length > 0 ) {

          selectedElement.addClass( cssClass );
        }
      }

      self.setApiUrl = function() {
        if ( ! self.postType ) {
          self.apiUrl = ''
        }

        self.apiUrl = pathName + '/wp-json/macs/v1/' + self.postType + '_search_results'

      }

      /**
       * Binds JS 'change' events to inputs
       * Every time the input is changed, this object's 'filterState' field
       * gets updated too and the browser's location hash is refreshed.
       */
      self.bindFiltersChange = function() {

        /**
         * bind all DOM inputs with js-filter class.
         * HTML "name" attribute will be used as filter name.
         */

        self.resultsContainer = $('.filters-content')
        self.postType = self.resultsContainer.attr('data-type')

        if ( 'event' === self.postType ) {

          $('body').addClass('all-events');

          $('.js-event-filter').on( 'click', function( e ) {

            e.preventDefault();

            $( '.js-event-filter.disable-button' ).each( function () {

              $( this ).removeClass( 'disable-button' );
            } );

            let $this = $( this );

            $this.toggleClass( 'disable-button' );

            let val = $this.data( 'value' );

            let name = 'events';

            self.filterState[name] = val;
            self.refreshUrl();
          } );

          $( '.js-event-type-filter' ).on( 'click', function( e ) {

            e.preventDefault();

            let $this = $( this );

            $this.toggleClass( 'selected-event-type' );

            let filterData = '';

            $( '.filter-container .selected-event-type' ).each( function () {

              let val = $( this ).data( 'value' );

              if ( '' !== filterData ) {

                filterData += '-' + val;

              } else {

                filterData = val;
              }
            } );

            self.filterState['events_type'] = filterData;
            self.refreshUrl();

          } );

        } else {

          $('.js-filter').on( 'change', function() {
            let val = $(this).val()
            let name = $(this).attr('name')

            if (self.postType == 'employee-testimonial' || self.postType == 'people' ) {
              self.resultsContainer.attr( 'data-page', 1 )
            }

            self.filterState[name] = val;
            self.refreshUrl()
          } )
        }

        // refresh results once seearch phrase is emptied
        $('.archive_phrase_search').on('keyup', debounce( function() {
          if ( '' === $(this).val() ) {
            self.filterState['search'] = '';
            self.refreshUrl()
          }
        }, 200 ) )

        /**
         * For search input the logic is a bit different
         * beacuse it's currently a form element so we need to bind submit event
         * and get search phrase from the first text input in a form
         */
        $( '.js-search-form' ).on( 'submit', function(e) {
          e.preventDefault();
          let searchInput = $(this).find('input[type=text]').first()
          let val = searchInput.val()
          let name = searchInput.attr('name')

          self.filterState[name] = val;
          self.refreshUrl()
        } )

        if ( 'podcast' === self.postType ) {
          let currentUrl = window.location.href; // phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment

          let queryString = currentUrl.substring( currentUrl.indexOf( '?' ) + 1 );

          let searchParams = new URLSearchParams( queryString );

          if ( ! searchParams.has( 'podcast_category' ) ) {
            $( '.podcast-tabs' ).each(function(i, obj) {
              if($(obj).attr('data-filter') === 'technology-labs') {
                $(obj).addClass('active');
              }
            });
            self.filterState['podcast_category'] = 'technology-labs';
            self.refreshUrl()
          } else {
            $( '.podcast-tabs' ).each(function(i, obj) {
              $(obj).removeClass('active');
              if($(obj).attr('data-filter') === searchParams.get( 'podcast_category' )) {
                $(obj).addClass('active');
              }
            });
          }
        }

        $( '.podcast-tabs' ).on( 'click', function(e) {
          e.preventDefault();
          let podcast_category = $(this).attr('data-filter')

          self.filterState['podcast_category'] = podcast_category;
          self.refreshUrl()
        } )
      }

      /**
       * Handles search results on page load
       */
      self.loadInitialState = function() {
        self.getFiltersFromUrl()
        self.setDOMFiltersValues()
        self.refreshResults()
      }

      /**
       * Restore filters values based on the URL
       * This is mainly used when the website is loaded with location has already populated
       * (to support deeplinking)
       */
      self.getFiltersFromUrl = function() {
        const hash = window.location.hash.replace(/[^=#%+&\w-(?!\&)]/g, ''); //phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment

        if ( ! hash ) {
          return
        }

        const queryString = hash.substring(1) // remove the '#'

        if ( ! queryString ) {
          return
        }

        const urlParams = new URLSearchParams( queryString );
        const params    = urlParams.entries()

        for(const [key, value] of params) {
          self.filterState[key] = value;
        }
      }

      /**
       * Reflects current filters state in html markup
       * This is  used when the website is loaded with location has already populated
       * (to support deeplinking)
       */
      self.setDOMFiltersValues = function() {
        for (const name in self.filterState) {
          const el = $('[name="'+name+'"]');
          const val = self.filterState[name].split(',')
          el.val(val)
          el.trigger('change')
        }
      }

      /**
       * Transforms params from URL into REST API request URL
       */
      self.getRequestUrlFromHash = function() {
        if ('event' === self.postType) {
          let url = window.location.href; // phpcs:ignore WordPressVIPMinimum.JS.Window.location

          if (url.indexOf('events=upcoming') > 0) {
            $('.upcomingEventBtn').trigger('focus');
          }
          if ( !window.location.search ) { // phpcs:ignore WordPressVIPMinimum.JS.Window.location
            window.history.replaceState({}, '', '?events=upcoming'); // phpcs:ignore WordPressVIPMinimum.JS.Window.location
            $('.upcomingEventBtn').trigger('focus');
            return self.apiUrl + '?events=upcoming';
          }
          else return self.apiUrl + window.location.search; // phpcs:ignore WordPressVIPMinimum.JS.Window.location
        } else {
          return self.apiUrl + window.location.search; // phpcs:ignore WordPressVIPMinimum.JS.Window.location
        }
      }

      /**
       * Sets new window location hash based on this object's filterState current value
       */
      self.refreshUrl = function() {
        let params = new URLSearchParams(self.filterState);

        if (self.postType) {
          window.history.replaceState({}, '', '?' + params); // phpcs:ignore WordPressVIPMinimum.JS.Window.location
          self.refreshResults();
        }
      }

      self.getCountAPIUrl = function() {
        let countUrl = pathName + '/wp-json/macs/v1/' + self.postType + '_search_results_count';
        let hash = window.location.hash.replace(/[^=#%+&\w-(?!\&)]/, ''); //phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment

        let queryString = hash.substring(1) // remove the '#'
        return countUrl + '?' + queryString
      }

      self.refreshResults = function( append = false) {

        let ajaxUrl = self.getRequestUrlFromHash()
        let etcountUrl = self.getCountAPIUrl();

        self.resultsContainer = $('.filters-content')
        self.postType = self.resultsContainer.attr('data-type')

        if (self.postType == 'event' ) {

          var subStr = ajaxUrl.match("events=(.*)");

          if (subStr != null ) {

            href = subStr[1].replace(/\&.*/,'');

            if ( ! href ) {

              $('body').addClass('all-events');
            } else {

              $('body').addClass(href);
              $('body').removeClass('all-events');
            }

            $('.js-event-filter').on( 'click', function() {

              $('body').removeClass(href);

              $(this).addClass(href);
            } );
          }
        }

        if ( append && self.postType !== 'employee-testimonial' && self.postType !== 'people' ) {
          let currentPage = self.resultsContainer.attr( 'data-page' )
          ajaxUrl = ajaxUrl + '&page=' + ( parseInt(currentPage, 10) + 1 )
        }

        if (self.postType == 'employee-testimonial' || self.postType == 'people') {
          let currentPage = self.resultsContainer.attr( 'data-page' )
          let ajaxUrlQuestionMark = (ajaxUrl.indexOf( '?' ) !== -1) ? '' : '?';
          let ajaxUrlAmpersandMark = (ajaxUrl.indexOf( '&' ) !== -1) ? '' : '&';
          ajaxUrl = ajaxUrl + ajaxUrlQuestionMark + ajaxUrlAmpersandMark + 'page=' + currentPage
        }
		
		if (self.postType === 'research-topics') {
			let category = (self.resultsContainer.attr('data-category') || '').trim();
			if (!category) {
				const searchCategory = new URLSearchParams(window.location.search).get('category');
				if (searchCategory) {
					category = searchCategory.trim();
				}
			}
			if (category) {
				ajaxUrl = ajaxUrl.includes('?') ? ajaxUrl + '&category=' + encodeURIComponent(category) : ajaxUrl + '?category=' + encodeURIComponent(category);
			}

		}
      if(self.postType !== 'podcast')
        self.fetchJobs( ajaxUrl, append )
      }      

      /**
       * Fetches data from REST API and renders results
       * @param  {[type]}  ajaxurl
       * @param  {Boolean} append  determines if new results replace existing ones or are appended
       */
      self.fetchJobs = function (ajaxurl, append = false) {

        self.noResultsNotice.hide()
        self.resultsContainer.addClass('loading');


        $.ajax({
          type: 'GET',
          url: ajaxurl,
          success: function (response, textStatus, jqXHR) {

            // the HTML template located in post type archive
            const itemTemplate = $('#search_result_item_template').html();

            if ( ! itemTemplate.length ) {
              return;
            }

            if ( !response.results || ! response.results.length) {
              if (!append) {
                self.resultsContainer.empty()
                self.noResultsNotice.show()
              }
              self.loadMoreBtn.hide()
              self.paginationContainer.hide()

              setTimeout( function() {
                self.resultsContainer.removeClass('loading');
              }, 300 )

              return
            } else {
              self.paginationContainer.show()
            }

            self.noResultsNotice.hide()


            // delete all items from previous search if not explicitly set to append
            if ( ! append || self.postType === 'employee-testimonial' || self.postType === 'people') {
              self.resultsContainer.empty()
            }

            for (let i = 0; i < response.results.length; i++) {
              var type = response.results[i].type;
              if (self.postType === 'analyst-report') {
                type = ( response.results[i].analyst !== '' ? response.results[i].analyst : ( response.results[i].industry !== '' ? response.results[i].industry : ( response.results[i].service !== '' ? response.results[i].service : ( response.results[i].partner !== '' ? response.results[i].partner : '' ) ) ) );
              }
              if (self.postType === 'client-story') {
                type = (type.indexOf(',') !== -1) ? type.split(',')[0] : type;
              }

              var post_link = response.results[i].url;

              var featured_image = response.results[i].featured_image;

              var featured_image_with_anchor = response.results[i].featured_image_with_anchor;

              var itemData = {
                title: response.results[i].title || '',
                url: post_link || '',
                type: type || '',
                theme: response.results[i].primary_term || '',
                date: response.results[i].date || '',
                location: response.results[i].location || '',
                eventtype: response.results[i].event_type || '',
                eventblocktitle: response.results[i].event_block_title || '',
                year: (response.results[i].event_block_title) ? '' : response.results[i].year,
                month: (response.results[i].event_block_title) ? '' : response.results[i].month,
                day: (response.results[i].event_block_title) ? '' : response.results[i].day,
                hour: response.results[i].hour || '',
                banner: response.results[i].banner || '',
                addtocalendstart: response.results[i].addtocalend_start || '',
                addtocalendend: response.results[i].addtocalend_end || '',
                eventclass: response.results[i].event_class || '',
                fileurl: response.results[i].file_url || '',
                filename: response.results[i].file_name || '',
                filetype: response.results[i].file_type || '',
                filesize: response.results[i].file_size || '',
                // Research and insights
                featuredimage: featured_image || '',
                featuredimagewithanchor: featured_image_with_anchor || '',
                authorurl: response.results[i].author_url || '',
                authorimage: response.results[i].author_image_html || '',
                authorname: response.results[i].author_name || '',
                brandimg: response.results[i].brand_img || '',
                // Terms
                analyst: response.results[i].analyst || '',
                industry: response.results[i].industry || '',
                service: response.results[i].service || '',
                partner: response.results[i].partner || '',
                // Blogs
                personimage: response.results[i].person_avatar || '',
                personname: response.results[i].person_name || '',
                // Employee Testimonials
                grade: response.results[i].grade || '',
                jobfamily: response.results[i].job_family || '',
                country: response.results[i].country || '',
                brand: response.results[i].brand || '',
                testimonialtitle: response.results[i].testimonial_title || '',
                excerpt: response.results[i].excerpt || '',
                //people
                expertposition: response.results[i].position || '',
                peopleprofileli: response.results[i].people_profile_li || '',
				        peopleprofiletw: response.results[i].people_profile_tw || '',
			         	peopleprofileemail: response.results[i].people_profile_email || '',
                //research-topics
                postresults: response.results[i].post_results || '',
                viewalllink: response.results[i].view_all_link || '',
                // podcast
                podcasturl: response.results[i].podcast_url || '',
                podcastoriginalurl: response.results[i].podcast_original_url || '',
                //research-authors
                cardhtml: response.results[i].card_html || '',
              }

              var html = itemTemplate.replace(/{{\s*([a-z]+)\s*}}/g, function (match, val) {
                return itemData[ val ] || ''
              })

              let $html = $(html)

              if ( 'event' === self.postType ) {

                if ( itemData['addtocalendstart'] === '' || itemData['addtocalendend'] === '' ) {
                  $html.find('.addeventatc').remove();
                }
              }

              if ( 'employee-testimonial' === self.postType ) {

                let boxTags = $html.find( '.box-tags' );

                // Add Tags.
                self.addTags( itemData['grade'], boxTags );
                self.addTags( itemData['jobfamily'], boxTags );
                self.addTags( itemData['country'], boxTags );
                self.addTags( itemData['brand'], boxTags );
              }

              if ( ! itemData['fileurl'] ) {
                $html.find('.link-download').remove()
              }

              if ( 'research-and-insight' === self.postType && ! itemData['authorname'] ) {
                $html.find('.box-author-img').remove()
                $html.find('.box-author-name').remove()
              }

              self.resultsContainer.append($html); //phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append

              if ( 'employee-testimonial' == self.postType || 'people' == self.postType) {
                var offset = $(".filters-content").parent().offset().top;
                var currPage = self.resultsContainer.attr( 'data-page' );
                var employeePagination = self.resultsContainer.attr( 'data-employee-pagination' );
                if ( currPage > 1 || ( 1 === parseInt( currPage ) && 1 === parseInt( employeePagination ) ) ) {
                  $("html, body").animate({
                    scrollTop: offset
                  }, 1);
                }
              }

              if( 'podcast' === self.postType ) {
                let currentUrl = window.location.href; // phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment

                let queryString = currentUrl.substring( currentUrl.indexOf( '?' ) + 1 );

                let searchParams = new URLSearchParams( queryString );

                if ( searchParams.has( 'podcast_category' ) && searchParams.get( 'podcast_category' ) === 'playing-with-reality' ) {
                  $('.podcast-box').each(function(i, obj) {
                    $(obj).find('.box-img-wrapper').css('width', '100%');
					          $(obj).find('.box-img-wrapper').css('height', '390px');
                	  $(obj).find('.box-inner').hide();
                	});
                }

                if ( searchParams.has( 'podcast_category' ) && searchParams.get( 'podcast_category' ) === 'technology-labs' ) {
                  $("#spotify_podcast_url").show();
                  $("#apple_podcast_url").show();
                  $("#sogeti_spotify_podcast_url").hide();
                }
                if ( searchParams.has( 'podcast_category' ) && searchParams.get( 'podcast_category' ) === 'sogeti-labs' ) {
                  $("#spotify_podcast_url").hide();
                  $("#apple_podcast_url").hide();
                  $("#sogeti_spotify_podcast_url").show();
                }
                if ( searchParams.has( 'podcast_category' ) && searchParams.get( 'podcast_category' ) === 'playing-with-reality' ) {
                  $("#spotify_podcast_url").hide();
                  $("#apple_podcast_url").hide();
                  $("#sogeti_spotify_podcast_url").hide();
                }
              }
            }

            setTimeout( function() {

              self.resultsContainer.removeClass('loading');

              if ( 'undefined' !== typeof addeventatc ) {

                // Refreshing add to calendar button.
                // Ref: https://www.addevent.com/add-to-calendar-button#anchor-faq
                addeventatc.refresh();

              }

            }, 300 );

            self.postType = self.resultsContainer.attr('data-type')

            // Load More button updates
            self.resultsContainer.attr( 'data-page', response.page )
            self.resultsContainer.attr( 'data-page-max', response.total_pages )
            self.updateLoadMoreBtn()

            /**
             * Not sure why this code is written, just commenting out as it is giving js error.
             */
            // Add to call update.
//          if ( 'event' === self.postType ) {
//            window.addeventatc.generate();
//          }

            //change pagination for employee testimonial page
            if (self.postType === 'employee-testimonial' || self.postType === 'people') {
              self.buildPagination(response)
            }


            self.refreshHovers()
          },
          error: function (jqXHR, textStatus, errorThrown) {
            if (textStatus === 'abort') {
              return;
            }
            self.loadMoreBtn.hide()
            if (!append) {
              self.noResultsNotice.show()
            }
          }
        })
      }

      /**
       * Append tags to particular post.
       *
       * @param array   itemDatas List of terms.
       * @param element boxTags   HTML element where needs to add those tags.
       *
       * @return void
       */
      self.addTags = function ( itemDatas, boxTags ) {

        if ( itemDatas.length > 0 ) {

          for( let j = 0; j < itemDatas.length; j++ ) {

            $( "<span />", { text: itemDatas[j].trim() } ).appendTo( boxTags ); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.appendTo
          }
        }
      }

      self.updateLoadMoreBtn = function() {
        let currentPage = parseInt(self.resultsContainer.attr( 'data-page' ), 10 )
        let maxPages    = parseInt( self.resultsContainer.attr( 'data-page-max' ), 10 )

        if ( maxPages > currentPage ) {
          self.loadMoreBtn.show()
          self.loadMoreBtn.parent().show()

          // refresh click binding
          self.loadMoreBtn.off().on( 'click', function(e) {
            e.preventDefault()
            self.refreshResults( true ) // append results from next page
          } )
        } else {
          self.loadMoreBtn.hide()
        }
      }

      self.buildPagination = function(response) {
        let currentPage = parseInt(self.resultsContainer.attr( 'data-page' ), 10 )
        let maxPages    = parseInt( self.resultsContainer.attr( 'data-page-max' ), 10 )

        let paginationHtml = '<div class="slider-nav">';
        let prevClass = 'inactive';
        let nextClass = '';
        let nextPageNo = ( parseInt(currentPage) + 1 );
        let prevPageNo = ( parseInt(currentPage) - 1 );

        if (currentPage > 1) {
          prevClass = 'active';
        }
        if (currentPage === maxPages) {
          nextClass = 'inactive';
        }

        var pageNumberArray = [];

        if (maxPages > 9) {
          if (currentPage > 5) {
            if ((maxPages - currentPage) < 4) {
              var diff = (maxPages - currentPage);
              var frontCount = 7 - (diff + 1);
              for (let i = 1; i <= frontCount; i++) {
                pageNumberArray.push(i);
              }
              pageNumberArray.push('...');
              for (let i = (currentPage - 1); i <= maxPages; i++) {
                pageNumberArray.push(i);
              }
            } else {
              for (let i = 1; i <= 3; i++) {
                pageNumberArray.push(i);
              }
              pageNumberArray.push('...');
              pageNumberArray.push(currentPage-1);
              pageNumberArray.push(currentPage);
              pageNumberArray.push(currentPage+1);
              pageNumberArray.push('...');
              pageNumberArray.push(maxPages-1);
              pageNumberArray.push(maxPages);
            }
          } else {
            if (currentPage === 5) {
              for (let i = 1; i <= 6; i++) {
                pageNumberArray.push(i);
              }
              pageNumberArray.push('...');
              pageNumberArray.push(maxPages-1);
              pageNumberArray.push(maxPages);
            } else {
              for (let i = 1; i <= 5; i++) {
                pageNumberArray.push(i);
              }
              pageNumberArray.push('...');
              pageNumberArray.push(maxPages-2);
              pageNumberArray.push(maxPages-1);
              pageNumberArray.push(maxPages);
            }
          }
        } else {
          for (let i = 1; i <= maxPages; i++) {
            pageNumberArray.push(i);
          }
        }

        if ( pageNumberArray.length > 1 ) {

          //Note: @todo Inform team to migrate this to template string.
          //  paginationHtml += '<button class="filters-pagination-btn slider-prev ' + prevClass + '" data-pageNo="' + prevPageNo + '"><span class="sr-only">pagination previous</span></button>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found


          if(prevClass === 'inactive') {

            paginationHtml += '<button tabindex="-1" class="filters-pagination-btn slider-prev ' + prevClass + '" data-pageNo="' + prevPageNo + '"><span class="sr-only">pagination previous</span></button>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found
          } else {
            paginationHtml += '<button tabindex="0" class="filters-pagination-btn slider-prev ' + prevClass + '" data-pageNo="' + prevPageNo + '"><span class="sr-only">pagination previous</span></button>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found
          }

          paginationHtml += '<ul class="slider-paginator">';

          for ( let i = 0; i < pageNumberArray.length; i ++ ) {

            let pageActive = '';

            let pageNumberHtml = '<a class="filters-pagination-btn" href="javascript:void(0)" aria-label="Page '+ pageNumberArray[i] +'" data-pageNo="' + pageNumberArray[i] + '">' + pageNumberArray[i] + '</a>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found

            if ( pageNumberArray[i] === '...' ) {
              pageNumberHtml = pageNumberArray[i];
            }

            if ( currentPage === pageNumberArray[i] ) {
              pageActive = 'active';
              pageNumberHtml = pageNumberArray[i];
            }

            // NOTE: Ignoring this as it is previous added code, so I don't want to conflicts at the moment.
            paginationHtml += '<li class="paginate-item ' + pageActive + '">' + pageNumberHtml + '</li>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found
          }

          paginationHtml += '</ul>';
          //Note: @todo inform team to migrated this to template string, ignoring this for now.
          //  paginationHtml += '<button class="filters-pagination-btn slider-next ' + nextClass + '" data-pageNo="' + nextPageNo + '"><span class="sr-only">pagination next</span></button>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found

          if(nextClass === 'inactive') {

            paginationHtml += '<button tabindex="-1" class="filters-pagination-btn slider-next ' + nextClass + '" data-pageNo="' + nextPageNo + '"><span class="sr-only">pagination next</span></button>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found
          } else {
            paginationHtml += '<button tabindex="0" class="filters-pagination-btn slider-next ' + nextClass + '" data-pageNo="' + nextPageNo + '"><span class="sr-only">pagination next</span></button>'; // phpcs:ignore WordPressVIPMinimum.JS.StringConcat.Found
          }

          paginationHtml += '</div>';
        }

        self.paginationContainer.html( paginationHtml ); //phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.html

        self.paginationBtn = $('.filters-pagination-btn')

        self.paginationBtn.off().on( 'click', function(e) {
          e.preventDefault()
          self.resultsContainer.attr( 'data-page', $(this).attr('data-pageNo'))
          self.resultsContainer.attr( 'data-employee-pagination', 1 )
          self.refreshResults( true )
        } )

      }

      self.refreshHovers = function() {
        $('a.box-title, a.box-title2, .more, .more2, .more4').hover(function(){
          $(this).parents('.box').find('a.box-title, a.box-title2, .more, .more2, .more4').addClass('hover')
        }, function(){
          $(this).parents('.box').find('a.box-title, a.box-title2, .more, .more2, .more4').removeClass('hover')
        })
      }
    }()

    ArchiveSearch.init();
  })

  // --- Preloader ---

  $(document).ready(function() {
    window.onload=new function() {
      $('.preloader').fadeOut(500, function(){ $('.preloader').remove(); } );
    };
  });

  // --- Hover everything in a box ---

  $('a.box-title, a.box-title2, .more, .more2, .more4').hover(function(){
    $(this).parents('.box').find('a.box-title, a.box-title2, .more, .more2, .more4').addClass('hover')
  }, function(){
    $(this).parents('.box').find('a.box-title, a.box-title2, .more, .more2, .more4').removeClass('hover')
  })

  // --- Menu ---

  function fixedMenu(){
    var myH = $('.header-topbar').not('.header-topbar-homepage').outerHeight()
    if($('.wp-block-cg-blocks-hero-bleed-card-image').length) {
      myH = $('.header-topbar').outerHeight()
    }

    if (myH) {
      if($('.sub-navigation').length <= 0){
        if ($(window).scrollTop() > 1){
          $('.header-topbar').addClass('fixed')
        } else {
          $('.header-topbar').removeClass('fixed')
        }
      }
      if($("#wpadminbar").length > 0){
        let height = $('.header-topbar').not('.header-topbar-homepage').outerHeight() + 25;
        // $('.header-topbar-wrapper').css('min-height', $('.header-topbar').not('.header-topbar-homepage').outerHeight());
      } else{
        let height = $('.header-topbar').not('.header-topbar-homepage').outerHeight() + 25;
        // $('.header-topbar-wrapper').css('min-height', height);
      }


    }
  }
  $(window).resize(function(){
    fixedMenu()
  })
  $(window).scroll(function() {
    fixedMenu()
  })
  fixedMenu()

  // --- Article ---

  if ($('.article').length) {
    var articleH
    function fixedArticleMenu(){
      var s = $('.article').position().top - $('.header-topbar').outerHeight()
      if ($(window).scrollTop() > s){
        $('.article-scroll').css('top', 0)
        $('.header-topbar, .sub-navigation').css('top', -150)
        $('.article-social').hide()
        var myScroll = $(window).scrollTop() - s
        $('.article-scrollbar').width(myScroll / articleH * 100 + '%')
      } else {
        $('.article-scroll, .header-topbar, .sub-navigation').attr('style', '')
        $('.article-social').show()
        $('.article-scrollbar').width(0)
      }
    }

    $(window).resize(function(){
      articleH = $('.article-body').outerHeight()
      fixedArticleMenu()
    })

    $(window).scroll(function() {
      fixedArticleMenu()
    })

    articleH = $('.article-body').outerHeight()
    fixedArticleMenu()

    $('.to-top').click(function(){
      $('html, body').animate({ scrollTop: 0 }, 500)
    })

    $(window).resize(debounce(fixedArticleMenu, 100))

  }

  // --- Resizer for fixed content-title on slider ---

  function partnerResize (){
    if ($('.section--event-slider').length > 0 && $(window).width() < 768) {
      var myTop = $('.section--event-slider .box-img-wrapper').height() + 24
      $('.section--event-slider .content-title').css('top', myTop)
    } else {
      $('.section--event-slider .content-title').attr('style', '')
    }
  }

  $(window).resize(debounce(

      function(){
        partnerResize()
      }, 100

  ))
  partnerResize()

  // --- Form ---

function filterManipulation() {
  $('select').each(function(){
    var myPlaceholder = $(this).attr('placeholder'),
        myParent = $(this).parent()

    if ($(this).attr('multiple') == 'multiple') {
      $(this).select2({
        placeholder: myPlaceholder,
        dropdownParent: myParent,
        closeOnSelect: true
      })

      $selection = myParent.find('.select2-selection')
      //$placeholder = $( '<div>', { 'text' : myPlaceholder } )
      $placeholder = $(`<div class="filters-option-dropdown">${myPlaceholder} </div>`)
      //  $placeholder = $(`<input type="text" readonly aria-label="${myPlaceholder} select dropdown" class="filters-multiselect-dropdown" value= ${myPlaceholder} style="min-width: 100px !important; background: transparent; border-bottom: none !important;"/>`);
      $placeholder.prependTo($selection)

      if ($(this).find('option').length < 10) {
        myParent.find('.select2-selection__rendered').hide()
      } else {
        myParent.addClass('hasSearch')
      }

      $('select').on('select2:open', function (e) {
        myParent.find('.select2-search__field').focus()
      })
      $(this).on('select2:open', function (e) {
        setTimeout(function() {
          $('.select2-results__option').each(function(){
            if($(this).attr('aria-selected') == 'true'){
              $(this).attr("aria-label",$(this).text()+" selected")
            }else{
              $(this).attr("aria-label",$(this).text())
            }
          });
        }, 100);
        //added for employee testimonial page's brand filter to remove scroll - starts
        var post_type = $('.filters-content').attr('data-type');
        if ( post_type === 'employee-testimonial' || post_type === 'people' ) {
          if ( $('ul#select2-select_et_brand-results').length ) {
            $('ul#select2-select_et_brand-results').addClass('no-scroll-et-brand');
          }
        }
        //added for employee testimonial page's brand filter to remove scroll - ends
      });

      $('select').on('change', function (e) {
        myParent.find('.select2-search__field').focus().attr('placeholder', myPlaceholder);
        setTimeout(function() {
          $('.select2-results__option').each(function(){
            if($(this).attr('aria-selected') == 'true'){
              $(this).attr("aria-label",$(this).text()+" selected")
            }else{
              $(this).attr("aria-label",$(this).text())
            }
          });
        }, 100);
      })

      $( this ).on('select2:close', function (e) {

        e.preventDefault();

        myParent.find( '.filters-multiselect-dropdown' ).focus();
      })
      $( this ).ready(function() {
        $('.select2-search__field').hide()
      });

    } else {
      var mySearch = 10
      if ($(this).find('option').length < 10) {
        mySearch = -1
      }

      $(this).select2({
        placeholder: myPlaceholder,
        dropdownParent: myParent,
        minimumResultsForSearch: mySearch,
        closeOnSelect: true
      })
    }
    var selectLabel= myParent.find('.select2-search__field');
    //  selectLabel.attr("aria-label", "" + myPlaceholder + " dropdown");
    $( document ).ready(function() {
      setTimeout(function() {
        $('.select2-results__option').each(function(){
          if($(this).attr('aria-selected') == 'true'){
            $(this).attr("aria-label",$(this).text()+" selected")
          }else{
            $(this).attr("aria-label",$(this).text())
          }
        });
      }, 100);
      $('.select2-selection--multiple').attr("tabindex",0);
    });
  })
}
filterManipulation();

  $('.form input, .form textarea').focusout(function(){
    if ($(this).val() != ''){
      $(this).addClass('full')
    } else {
      $(this).removeClass('full')
    }
  })

  $('.form--oneliner input').not('.noeffect-input').on('keyup', function(){
    if ($(this).val() != ''){
      $(this).parents('.form--oneliner').addClass('full')
    } else {
      $(this).parents('.form--oneliner').removeClass('full')
    }
  })

  var val = [];
  $('.year-filter > option').each(function() {
    val.push($(this).text());
  });

  if ( val.length !== 0 ) {
    var min = Math.min(...val)
    var max = Math.max(...val)
  } else {
    var min = 0
    var max = 0
  }

  if ( 0 !== min ) {
    var date = '01/01/' + min;
  } else {
    var date = $.datepicker.formatDate('dd/mm/yy', new Date());
  }

  function creatDateFilterTag(elem, dateCat) {
    if($(elem).val() !== '') {

      var filtersParent = $( elem ).parents( '.filters' );
      $( '.filter-date-tag[data-filter="' + elem.id + '"]' ).remove();

      // Add tags
      var template = '<span class="filters-tag filter-date-tag"><button class="filters-tag-remove" aria-label="close"><i class="icon-close" aria-hidden="true"></i></button> \
        <span></span></span>';
      let temp = $( template );

      let filteredButton = $( temp ).find( 'span' );

      filteredButton.text( $( elem ).val() );
      filteredButton.attr( 'data-value', $( elem ).val() );

      $( temp ).attr( 'data-filter', elem.id );

      if ( 'pr_datefrom' !== elem.id && 'pr_dateto' !== elem.id ) {
        // NOTE: Ignoring this as it is previous added code, so I don't want to conflict at the moment.
        filtersParent.find( '.filters-tags-list' ).append( $( temp ) ); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append
      }
    }

    if(filtersParent.find('.filters-tag') && filtersParent.find('input[name=date-from]') && filtersParent.find('input[name=date-to]')){
        if (filtersParent.find('.filters-tag').length > 0 || filtersParent.find('input[name=date-from]').val() || filtersParent.find('input[name=date-to]').val() ){
            filtersParent.find('.filters-clear').show()
        }
    }
  }

  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // Date from filters
  $('#pr_datefrom').datepicker({
    showOn: "none", //Remove default open on focus
    dateFormat: 'dd/mm/yy',
    changeMonth: true,
    changeYear:true,
    // yearRange: min + ':' + max,
    defaultDate: date,
    showButtonPanel: true,
    closeText: 'Clear',
    onSelect: function(dateText, inst){
      let fullDate = monthNames[$(this).datepicker('getDate').getMonth()]+' '+$(this).datepicker('getDate').getDate()+', '+$(this).datepicker('getDate').getFullYear();
      $('#pr_dateto').datepicker('option', 'minDate', dateText);
      $(this).val(fullDate);
      creatDateFilterTag(this);
      $(this).trigger('change');
    },
    onChangeMonthYear: function (element) {
      localStorage.setItem('prevDateFocusItem', document.activeElement.className);
      $(this).attr('disabled',true);
      setTimeout(function(){
        $('#pr_datefrom').attr('disabled',false);
      },100);
    },
    onClose: function () {
      if(arguments.callee.caller !== null){
          var event = arguments.callee.caller.caller.arguments[0];
          if (event) {
            if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
              $(this).val('')
              $(this).trigger('change')
            }
          }
      }
      $(this).parent().removeClass("datefield-open");
    },
    beforeShow: function(input, inst)
    {
      $(this).parent().addClass("datefield-open");
      $('#ui-datepicker-div').insertAfter($(this).parent());
      $(this).parent().parent().css('position','initial');
    }
  });

  /**
   * Dynamically set the click / keyboard events to the datepicker input fields.
   * We have disabled the default show widget on focus using showOn: "none" for the
   * datepickers for consistent behaviour with the other filter elements.
   */

  /**
   * Set the date picker elements html Ids
   * @type {string[]}
   */
  const datePickerEleIds = ["#pr_datefrom", "#pr_dateto", "#ra_datefrom", "#ra_dateto"];

  /**
   * Get the datepicker input elements
   * @type {Array<HTMLInputElement | null>}
   */
  const datePickerNodes = datePickerEleIds.map((id) => document.querySelector(id));

  /**
   * Toggle the datepicker widget based on click or enter key
   * @param datePickerNode {HTMLInputElement}
   * @param e {MouseEvent | KeyboardEvent}
   */
  const toggleDatePickerWidget = (datePickerNode, e) => {
    if(e.type === 'click' || e.code === 'Enter' || e.keyCode === 13) {
      if($(datePickerNode).datepicker( "widget" ).is(":visible")){
        $(datePickerNode).datepicker('hide');
      } else {
        $(datePickerNode).datepicker('show');
      }
    }
  }

  /**
   * Loop through the datepicker elements and assign event listeners
   */
  datePickerNodes.forEach((datePickerNode) => {
    if(datePickerNode) {
      ['click', 'keydown'].forEach((eventName) => {
        datePickerNode.addEventListener(eventName, (e) => {
          toggleDatePickerWidget(datePickerNode, e);
        })
      })
    }
  });


  $('#ra_datefrom').datepicker({
    //dateFormat: 'dd MM, yy',
    dateFormat: 'dd/mm/yy',
    showOn: "none",
    changeMonth: true,
    changeYear:true,
    // yearRange: min + ':' + max,
    defaultDate: date,
    showButtonPanel: true,
    closeText: 'Clear',
    onSelect: function(dateText, inst){
      $('#ra_dateto').datepicker('option', 'minDate', dateText);
      $(this).trigger('change')
    },
    onClose: function () {
      var event = arguments.callee.caller.caller.arguments[0];
      if (event) {
        if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
          $(this).val('')
          $(this).trigger('change')
        }
      }
    }
  });


  // Date to filters
  $('#pr_dateto').datepicker({
    showOn: "none",
    dateFormat: 'dd/mm/yy',
    changeMonth: true,
    changeYear:true,
    // yearRange: min + ':' + max,
    defaultDate: date,
    showButtonPanel: true,
    closeText: 'Clear',
    onSelect: function(dateText, inst){
      let fullDate = monthNames[$(this).datepicker('getDate').getMonth()]+' '+$(this).datepicker('getDate').getDate()+', '+$(this).datepicker('getDate').getFullYear();
      $(this).val(fullDate);
      creatDateFilterTag(this);
      $(this).trigger('change');
    },
    onChangeMonthYear: function (element) {
      localStorage.setItem('prevDateFocusItem', document.activeElement.className);
      $(this).attr('disabled',true);
      setTimeout(function(){
        $('#pr_dateto').attr('disabled',false);
      },100)
    },
    onClose: function () {
        if(arguments.callee.caller !== null){
            var event = arguments.callee.caller.caller.arguments[0];
            if (event) {
                if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
                    $(this).val('')
                    $(this).trigger('change')
                }
            }
        }
      $(this).parent().removeClass("datefield-open");
    },
    beforeShow: function(input, inst)
    {
      $(this).parent().addClass("datefield-open");
      $('#ui-datepicker-div').insertAfter($(this).parent());
      $(this).parent().parent().css('position','initial');
    }
  })

  $('#ra_dateto').datepicker({
    //dateFormat: 'dd MM, yy',
    dateFormat: 'dd/mm/yy',
    showOn: "none",
    changeMonth: true,
    changeYear:true,
    // yearRange: min + ':' + max,
    defaultDate: date,
    showButtonPanel: true,
    closeText: 'Clear',
    onClose: function () {
      var event = arguments.callee.caller.caller.arguments[0];
      if (event) {
        if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
          $(this).val('')
          $(this).trigger('change')
        }
      }
    }
  })

  // Year filter values in date from / date to

  $('.year-filter').on( 'change', function() {

//    // Clear date from / ddate to filters
//    $('#pr_datefrom').val('')
//    $('#pr_datefrom').trigger('change')
//    $('#ra_datefrom').val('')
//    $('#ra_datefrom').trigger('change')
//    $('#pr_dateto').val('')
//    $('#pr_dateto').trigger('change')
//    $('#ra_dateto').val('')
//    $('#ra_dateto').trigger('change')

    let allYearOptions = $(this).val()

    if ( 0 === allYearOptions.length ) {

      allYearOptions = [];

      $( this ).find( 'option' ).each( function () {
        allYearOptions.push( $( this ).val() );
      } );
    }

    let min = Math.min(...allYearOptions);
    let max = Math.max(...allYearOptions);

    let date = $.datepicker.formatDate('mm/dd/yy', new Date());

    if ( 0 !== min ) {
      date = '01/01/' + min;
    }

    // Date from filters
    $('#pr_datefrom').datepicker('destroy')
    $('#ra_datefrom').datepicker('destroy')

    $('#pr_datefrom').datepicker({
      showOn: "none",
      dateFormat: 'dd/mm/yy',
      changeMonth: true,
      changeYear:true,
      yearRange: min + ':' + max,
      defaultDate: date,
      showButtonPanel: true,
      closeText: 'Clear',
      onSelect: function(dateText, inst){
        let fullDate = monthNames[$(this).datepicker('getDate').getMonth()]+' '+$(this).datepicker('getDate').getDate()+', '+$(this).datepicker('getDate').getFullYear();
        $('#pr_dateto').datepicker('option', 'minDate', dateText);
        $(this).val(fullDate);
        creatDateFilterTag(this);
        $(this).trigger('change');
      },
      onClose: function () {
          if(arguments.callee.caller !== null){
              var event = arguments.callee.caller.caller.arguments[0];
              if (event) {
                if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
                  $(this).val('')
                  $(this).trigger('change')
                }
              }
          }
        $(this).parent().removeClass("datefield-open");
      },
      beforeShow: function(input, inst)
      {
        $(this).parent().addClass("datefield-open");
        $('#ui-datepicker-div').insertAfter($(this).parent());
        $(this).parent().parent().css('position','initial');
      },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
        $(this).attr('disabled',true);
        setTimeout(function(){
          $('#pr_datefrom').attr('disabled',false);
        },100);
      }
    })

    $('#ra_datefrom').datepicker({
      //dateFormat: 'dd MM, yy',
      showOn: "none",
      changeMonth: true,
      changeYear:true,
      yearRange: min + ':' + max,
      defaultDate: date,
      showButtonPanel: true,
      closeText: 'Clear',
      onSelect: function(dateText, inst){
        $('#ra_dateto').datepicker('option', 'minDate', dateText);
        $(this).trigger('change')
      },
      onClose: function () {
        var event = arguments.callee.caller.caller.arguments[0];
        if (event) {
          if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
            $(this).val('')
            $(this).trigger('change')
          }
        }
      }
    })

    // Date to filters
    $('#pr_dateto').datepicker('destroy')
    $('#ra_dateto').datepicker('destroy')

    $('#pr_dateto').datepicker({
      showOn: "none",
      dateFormat: 'dd/mm/yy',
      changeMonth: true,
      changeYear:true,
      yearRange: min + ':' + max,
      defaultDate: date,
      showButtonPanel: true,
      closeText: 'Clear',
      onSelect: function(dateText, inst){
        let fullDate = monthNames[$(this).datepicker('getDate').getMonth()]+' '+$(this).datepicker('getDate').getDate()+', '+$(this).datepicker('getDate').getFullYear();
        $(this).val(fullDate);
        creatDateFilterTag(this);
        $(this).trigger('change');
      },
      onClose: function () {
          if(arguments.callee.caller !== null){
              var event = arguments.callee.caller.caller.arguments[0];
              if (event) {
                if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
                  $(this).val('')
                  $(this).trigger('change')
                }
              }
          }
        $(this).parent().removeClass("datefield-open");
      },
      beforeShow: function(input, inst)
      {
        $(this).parent().addClass("datefield-open");
        $('#ui-datepicker-div').insertAfter($(this).parent());
        $(this).parent().parent().css('position','initial');
      },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
        $(this).attr('disabled',true);
        setTimeout(function(){
          $('#pr_dateto').attr('disabled',false);
        },100);
      }
    })

    $('#ra_dateto').datepicker({
      //dateFormat: 'dd MM, yy',
      showOn: "none",
      changeMonth: true,
      changeYear:true,
      yearRange: min + ':' + max,
      defaultDate: date,
      showButtonPanel: true,
      closeText: 'Clear',
      onClose: function () {
        var event = arguments.callee.caller.caller.arguments[0];
        if(event) {
          if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
            $(this).val('')
            $(this).trigger('change')
          }
        }
      }
    })
  })


  //cleardates


  $('#clearDates').on('click', function () {


    $('#pr_datefrom').datepicker('destroy');
    $('#ra_datefrom').datepicker('destroy');


    $('#pr_dateto').datepicker('destroy');
    $('#ra_dateto').datepicker('destroy');

    var val = [];
    $('.year-filter > option').each(function() {
      val.push($(this).text());
    });

    if ( val.length !== 0 ) {
      var min = Math.min(...val)
      var max = Math.max(...val)
    } else {
      var min = 0
      var max = 0
    }

    if ( 0 !== min ) {
      var date = '01/01/' + min;
    } else {
      var date = $.datepicker.formatDate('mm/dd/yy', new Date())
    }

// Date from filters
    $('#pr_datefrom').datepicker({
      showOn: "none",
      dateFormat: 'dd/mm/yy',
      changeMonth: true,
      changeYear:true,
      yearRange: min + ':' + max,
      defaultDate: date,
      showButtonPanel: true,
      closeText: 'Clear',
      onSelect: function(dateText, inst){
        let fullDate = monthNames[$(this).datepicker('getDate').getMonth()]+' '+$(this).datepicker('getDate').getDate()+', '+$(this).datepicker('getDate').getFullYear();
        $('#pr_dateto').datepicker('option', 'minDate', dateText);
        $(this).val(fullDate);
        creatDateFilterTag(this);
        $(this).trigger('change');
      },
      onClose: function () {
          if(arguments.callee.caller !== null){
              var event = arguments.callee.caller.caller.arguments[0];
              if (event) {
                if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
                  $(this).val('')
                  $(this).trigger('change')
                }
              }
          }
        $(this).parent().removeClass("datefield-open");
      },
      beforeShow: function(input, inst)
      {
        $(this).parent().addClass("datefield-open");
        $('#ui-datepicker-div').insertAfter($(this).parent());
        $(this).parent().parent().css('position','initial');
      },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
        $(this).attr('disabled',true);
        setTimeout(function(){
          $('#pr_datefrom').attr('disabled',false);
        },100);
      },
    })

    $('#ra_datefrom').datepicker({
      //dateFormat: 'dd MM, yy',
      showOn: "none",
      changeMonth: true,
      changeYear:true,
      yearRange: min + ':' + max,
      defaultDate: date,
      showButtonPanel: true,
      closeText: 'Clear',
      onSelect: function(dateText, inst){
        $('#ra_dateto').datepicker('option', 'minDate', dateText);
        $(this).trigger('change')
      },
      onClose: function () {
        var event = arguments.callee.caller.caller.arguments[0];
        if(event){
          if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
            $(this).val('')
            $(this).trigger('change')
          }
        }
      }
    })

    // Date to filters
    $('#pr_dateto').datepicker({
      showOn: "none",
      dateFormat: 'dd/mm/yy',
      changeMonth: true,
      changeYear:true,
      yearRange: min + ':' + max,
      defaultDate: date,
      showButtonPanel: true,
      closeText: 'Clear',
      onSelect: function(dateText, inst){
        let fullDate = monthNames[$(this).datepicker('getDate').getMonth()]+' '+$(this).datepicker('getDate').getDate()+', '+$(this).datepicker('getDate').getFullYear();
        $(this).val(fullDate);
        creatDateFilterTag(this);
        $(this).trigger('change');
      },
      onClose: function () {
        creatDateFilterTag(this);
        if(arguments.callee.caller !== null){
            var event = arguments.callee.caller.caller.arguments[0];
            if (event) {
              if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
                $(this).val('')
                $(this).trigger('change')
              }
            }
        }
        $(this).parent().removeClass("datefield-open");
      },
      beforeShow: function(input, inst)
      {
        $(this).parent().addClass("datefield-open");
        $('#ui-datepicker-div').insertAfter($(this).parent());
        $(this).parent().parent().css('position','initial');
      },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
        $(this).attr('disabled',true);
        setTimeout(function(){
          $('#pr_dateto').attr('disabled',false);
        },100);
      },
    })

    $('#ra_dateto').datepicker({
      //dateFormat: 'dd MM, yy',
      showOn: "none",
      changeMonth: true,
      changeYear:true,
      yearRange: min + ':' + max,
      defaultDate: date,
      showButtonPanel: true,
      closeText: 'Clear',
      onClose: function () {
        var event = arguments.callee.caller.caller.arguments[0];
        if(event){
          if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
            $(this).val('')
            $(this).trigger('change')
          }
        }
      }
    })

  })


  //tagscleardates


  $('.filters-tags-list').on('click', function () {


    $('#pr_datefrom').datepicker('destroy');
    $('#ra_datefrom').datepicker('destroy');


    $('#pr_dateto').datepicker('destroy');
    $('#ra_dateto').datepicker('destroy');

    var val = [];
    $('.year-filter > option').each(function() {
      val.push($(this).text());
    });

    if ( val.length !== 0 ) {
      var min = Math.min(...val)
      var max = Math.max(...val)
    } else {
      var min = 0
      var max = 0
    }

    if ( 0 !== min ) {
      var date = '01/01/' + min;
    } else {
      var date = $.datepicker.formatDate('mm/dd/yy', new Date())
    }


// Date from filters
    $('#pr_datefrom').datepicker({
      showOn: "none",
      dateFormat: 'dd/mm/yy',
      changeMonth: true,
      changeYear:true,
      yearRange: min + ':' + max,
      defaultDate: date,
      showButtonPanel: true,
      closeText: 'Clear',
      onSelect: function(dateText, inst){
        let fullDate = monthNames[$(this).datepicker('getDate').getMonth()]+' '+$(this).datepicker('getDate').getDate()+', '+$(this).datepicker('getDate').getFullYear();
        $('#pr_dateto').datepicker('option', 'minDate', dateText);
        $(this).val(fullDate);
        creatDateFilterTag(this);
        $(this).trigger('change');
      },
      onClose: function () {
          if(arguments.callee.caller !== null){
              var event = arguments.callee.caller.caller.arguments[0];
              if (event) {
                if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
                  $(this).val('')
                  $(this).trigger('change')
                }
              }
          }
        $(this).parent().removeClass("datefield-open");
      },
      beforeShow: function(input, inst)
      {
        $(this).parent().addClass("datefield-open");
        $('#ui-datepicker-div').insertAfter($(this).parent());
        $(this).parent().parent().css('position','initial');
      },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
        $(this).attr('disabled',true);
        setTimeout(function(){
          $('#pr_datefrom').attr('disabled',false);
        },100);
      }
    })

    $('#ra_datefrom').datepicker({
      //dateFormat: 'dd MM, yy',
      showOn: "none",
      changeMonth: true,
      changeYear:true,
      yearRange: min + ':' + max,
      defaultDate: date,
      showButtonPanel: true,
      closeText: 'Clear',
      onSelect: function(dateText, inst){
        $('#ra_dateto').datepicker('option', 'minDate', dateText);
        $(this).trigger('change')
      },
      onClose: function () {
        var event = arguments.callee.caller.caller.arguments[0];
        if(event) {
          if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
            $(this).val('')
            $(this).trigger('change')
          }
        }
      }
    })

    // Date to filters
    $('#pr_dateto').datepicker({
      dateFormat: 'dd/mm/yy',
      showOn: "none",
      changeMonth: true,
      changeYear:true,
      yearRange: min + ':' + max,
      defaultDate: date,
      showButtonPanel: true,
      closeText: 'Clear',
      onSelect: function(dateText, inst){
        let fullDate = monthNames[$(this).datepicker('getDate').getMonth()]+' '+$(this).datepicker('getDate').getDate()+', '+$(this).datepicker('getDate').getFullYear();
        $(this).val(fullDate);
        creatDateFilterTag(this);
        $(this).trigger('change');
      },
      onClose: function () {
          if(arguments.callee.caller !== null){
              var event = arguments.callee.caller.caller.arguments[0];
              if (event) {
                if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
                  $(this).val('')
                  $(this).trigger('change')
                }
              }
          }
        $(this).parent().removeClass("datefield-open");
      },
      beforeShow: function(input, inst)
      {
        $(this).parent().addClass("datefield-open");
        $('#ui-datepicker-div').insertAfter($(this).parent());
        $(this).parent().parent().css('position','initial');
      },
      onChangeMonthYear: function (element) {
        localStorage.setItem('prevDateFocusItem', document.activeElement.className);
        $(this).attr('disabled',true);
        setTimeout(function(){
          $('#pr_dateto').attr('disabled',false);
        },100);
      }
    })

    $('#ra_dateto').datepicker({
      //dateFormat: 'dd MM, yy',
      showOn: "none",
      changeMonth: true,
      changeYear:true,
      yearRange: min + ':' + max,
      defaultDate: date,
      showButtonPanel: true,
      closeText: 'Clear',
      onClose: function () {
        var event = arguments.callee.caller.caller.arguments[0];
        if(event) {
          if ($(event.delegateTarget).hasClass('ui-datepicker-close')) {
            $(this).val('')
            $(this).trigger('change')
          }
        }
      }
    })

  })

  var filter = $('.filters-content')
  var postType = filter.attr('data-type')

  if (postType == 'event' ) {

    if (window.ifaddtocalendar === undefined) {
      window.ifaddtocalendar = 1
      var d = document; var s = d.createElement('script'); var g = 'getElementsByTagName'; var h = d[g]('body')[0]
      s.type = 'text/javascript'; s.charset = 'UTF-8'; s.async = true
      s.src = (window.location.protocol === 'https:' ? 'https' : 'http') + '://addevent.com/libs/atc/1.6.1/atc.min.js' // phpcs:ignore WordPressVIPMinimum.JS.Window.location
      h.appendChild(s)
    }
  }

})

$(function(){


  const hideLangTitles = () => {
    try {
      const langTitles = document.querySelectorAll('.lang-title');
      if(langTitles && langTitles.length > 0) {
        langTitles.forEach((langTitleNode) => {
          let subMenu = langTitleNode.nextElementSibling;
          const allLiElements = subMenu.querySelectorAll('li');
          if(allLiElements && allLiElements.length > 0) {
            const hiddenLiElements = Array.from(allLiElements).filter((liElement) => {
              return window.getComputedStyle(liElement).getPropertyValue('display') == 'none';
            });
            if(allLiElements.length === hiddenLiElements.length) {
              langTitleNode.style.display = 'none';
            }
          }
        })
      }
    } catch (e) {
      console.log(e);
    }
  }

  // lang search in menu for desktop
  //Fix bug 486503 happening because proper exception handling was not done.
  try {
    const searchInput = document.querySelector('#search-location-input');
    if(searchInput) {
      searchInput.addEventListener('input', function(e) {
        const menuLocations = document.querySelectorAll('.header_lang_menu .location-span')
        const searchedLocation = e.target.value
        menuLocations.forEach(item => item.innerHTML.toLowerCase().includes(searchedLocation.toLowerCase()) ? item.closest('li').style.display="block" : item.closest('li').style.display="none" );
        hideLangTitles();
      });
    }
  } catch (e) {
    //Error happened
    console.log(e);
  }
  // lang search in menu for mobile
  try {
    const searchInput = document.querySelector('#search-location-input_mobile');
    if(searchInput) {
      searchInput.addEventListener('input', function(e) {
        const menuLocations = document.querySelectorAll('.header_lang_menu_mobile .location-span')
        const searchedLocation = e.target.value
        menuLocations.forEach(item => item.innerHTML.toLowerCase().includes(searchedLocation.toLowerCase()) ? item.closest('li').style.display="block" : item.closest('li').style.display="none" )
        hideLangTitles();
      });
    }
  } catch (e) {
    //Error happened
    console.log(e);
  }

})


$(document).ready(function() {

  /**
   * Commenting this function as this is not recommended
   * to use keypress event
   */
  // $(".menu-arrow-down").keypress(function(e) {
  //   if(e.which == 13) {
  //     if($(this).next(".menu-submenu").hasClass("menu-open")){
  //       $('.menu-submenu').removeClass("menu-open");
  //       $(this).attr("aria-expanded", "false");
  //     }else{
  //       $('.menu-submenu').removeClass("menu-open");
  //         $(this).next(".menu-submenu").addClass("menu-open");
  //         $(this).attr("aria-expanded", "true");
  //       }
  //     }
  //   });

  // $(".menu-arrow-down").on('keydown blur', function(e) {
  //   if (e.shiftKey && e.keyCode === 9) {
  //     if($( ".menu-submenu" ).hasClass( "menu-open" )){
  //       $('.menu-submenu').removeClass("menu-open");
  //       $(this).attr("aria-expanded", "false");
  //     }
  //   }
  // });

  $(".header-search-button").focus(function(e) {
    if($( ".menu-submenu" ).hasClass( "menu-open" )){
      $('.menu-submenu').removeClass("menu-open");
      $(".menu-arrow-down").attr("aria-expanded", "false");
    }
  });

  $(".menu-parent a").focus(function(e){
    $(this).parent().children().children().eq(1).css({"opacity": "1", "z-index": "101"});
  });



  $(".menu-parent a").on('keydown blur', function(e) {
    if (e.shiftKey && e.keyCode === 9) {
      if($(this).parent().children().children().eq(1).css({"opacity": "1", "z-index": "101"})){
        $(this).parent().children().children().eq(1).css({"opacity": "0", "z-index": "-1"});
      }
    }
  });

  $(".menu-arrow-down").focus(function(e){
    $(".menu-l2").css({"opacity": "0", "z-index": "-1"});
  });
});

/*Only for Analust page Footer space */
$(document).ready(function() {
  if($("#analystContactUsWrapper").length === 1) {
    $(".footer").css("margin-top", "0px");
  }
});

/*Only for Event Agenda block Footer space */
$(document).ready(function () {
  if ($("#eventAgendaWrapper").length === 1) {
    $(".footer").css("margin-top", "0px");
  }
});

/*Only for article content block with intro para block
$(document).ready(function () {
  if ($("#introParaWrapper").length === 1) {

    $('#quoteWrapper').attr('style', 'padding-top: 0px !important');
  }
});

/*Only for article content block

$(document).ready(function () {
var modals = document.querySelectorAll('#quoteWrapper')
modals.forEach(function(modal) {
  $(modal).attr('style', 'padding-top: 0px !important');
});
});
*/
/* script for Location page */
$(document).ready(function() {
  if ( $(".section--locations-expanders").length && ! $(".section--locations-expanders").find('.research-archive-filter').length ) {
    var offset = $(".section--locations-expanders").offset().top;
    offset = offset - 50;
    $(".filters-nav-anchor").on("click", function() {
      $("html, body").animate({
        scrollTop: offset
      }, 500);
    });
  }

  // CTA Modal Fix
  $('.cta-frontend-modal-wrapper').on('shown.bs.modal', function(){
   // $("body").css("position", "fixed");
    $('.cta-frontend-modal-wrapper .form_country_select').removeAttr('tabindex');
  });

  $('.cta-frontend-modal-wrapper').on('hidden.bs.modal', function(){
    //$("body").css("position", "static");
  });

  let locationSearchInput = $( '#pac-input' );

  let locationSearchResults = $( '#box_location_search' );

  if ( locationSearchInput.length > 0 ) {

    $( document ).on( 'click', '#box_location_search p', function() {

      locationSearchInput.val( $( this ).text() );

      locationSearchResults.empty();

    } );
  }

  /*
  * Populate expert title in the hidden field on clicking email icon
  * on Wrapper-get-in-touch and Wrapper-people-slider blocks
  */
  $('a[data-bs-expert-title]').click( function(event) {
    let expert_title = $( this ).attr('data-bs-expert-title');
    let bs_target = $( this ).attr('data-bs-target');
    let getInTouchForm = $( bs_target ).find( '.mf_form__form' );
    let hidden_field = getInTouchForm.find( 'input[data-hidden-field-tag="expert_title"]' );
    hidden_field.val( expert_title );
  });

  $( '#bs-modal-get-in-touch' ).on( 'shown.bs.modal', function () {

    let $this = $( this );

    let getInTouchForm = $this.find( '.mf_form__form' );

    getInTouchForm.trigger( 'reset' );

    let select2s = getInTouchForm.find( '.select2-hidden-accessible' );

    if ( select2s.length > 0 ) {

      select2s.each( function () {

        $( this ).val( null ).trigger( 'change' );

      } );
    }

    // Reset captcha.
    if ( 'undefined' !== typeof grecaptcha ) {

      grecaptcha.reset();
    }

    getInTouchForm.removeClass( 'was-validated' );

    getInTouchForm.show();

    $this.find( '.mf_form__success' ).hide();

  } );

});

// Double search button fix in hero career

$('.search-button.hero-career-search-button, .search-button.common-top-search-button').on('focus', function(){
  $(this).parents('form').addClass('hide-after');
  $(this).removeClass('hide');
});

$('.search-button.hero-career-search-button, .search-button.common-top-search-button').attr('tabindex','-1');

$('.search-button.hero-career-search-button, .search-button.common-top-search-button').on('keyup', function(){
  $(this).parents('form').removeClass('hide-after');
  const valueOfInput = $(this).parents('form').find('.archive_phrase_search.noeffect-input').val();

  let archiveSearchButtonCommon = $(this).parents('form').find('.search-button');

  if(valueOfInput && valueOfInput !== '' ){
    $('.search-button.hero-career-search-button, .search-button.common-top-search-button').attr('tabindex','0');
    archiveSearchButtonCommon.removeClass('hide');
  }else{
    archiveSearchButtonCommon.addClass('hide');
  }
});

$('.archive_phrase_search.noeffect-input.hero-career-search-input, .archive_phrase_search.noeffect-input.common-top-search-input').on("input",function(){
  const valueOfInput = this.value;

  let archiveSearchButtonCommon = $(this).parents('form').find('.search-button');

  if ( valueOfInput && '' !== valueOfInput ) {
    $('.search-button.hero-career-search-button, .search-button.common-top-search-button').attr('tabindex','0');
    archiveSearchButtonCommon.removeClass('hide');
  } else {
    archiveSearchButtonCommon.addClass('hide');
  }
});

// Archive search input

$('.search-button.archive-search-button').on('focus', function(){
  $(this).parents('form').addClass('hide-after');
  $(this).removeClass('d-none');
});

$('.search-button.archive-search-button').attr('tabindex','-1');

$('.search-button.archive-search-button').on('keyup', function(){
  $(this).parents('form').removeClass('hide-after');
  const valueOfInput = $(this).parents('form').find('.archive_phrase_search.noeffect-input').val();
  if(valueOfInput && valueOfInput !== '' ){
    //  $(this).removeClass('d-none');
    $(this).removeClass('hide-after');
  }else{
    $(this).addClass('d-none');
  }
});


$('.archive_phrase_search.noeffect-input.archive-search-input').on("input",function(){
  const valueOfInput = this.value;

  let archiveSearchButton = $(this).parents('form').find('.search-button.archive-search-button');

  if(valueOfInput && valueOfInput !== '' ){
    archiveSearchButton.removeClass('d-none');
    $('.search-button.archive-search-button').attr('tabindex','0');
  } else {
    archiveSearchButton.addClass('d-none');
  }
});

//Skip to content by tab
var skipToContenttAmt = $('.header-topbar-wrapper').height();
$('#skip-nav').click(function(event){
  if($('.sub-navigation-wrapper').length < 1) {
    $([document.documentElement, document.body]).animate({
      scrollTop: skipToContenttAmt
    }, 100);
  }
});


// country dropdown, filter accessibility

$(document).on("DOMNodeInserted", function() {

  // Country dropdown.
  $( this ).find( '.mf-country-selectbox.select2-hidden-accessible' ).removeAttr( 'tabindex' );

  $('.mf_forms__container .select2-hidden-accessible').focus(function() {
    $(this).parent().addClass('country-select-wrapper');
  }).focusout(function() {
    $(this).parent().removeClass('country-select-wrapper');
  })

  $( '#ui-datepicker-div' ).find( 'a.ui-state-default' ).attr('href', 'javascript:void(0)');


  //Search result input focus

  $('section.search-result.archive-pages #pr_form_subbmit').focus(function() {
    $(this).parent().addClass('searchResultInputFocused');
  })
  $('section.search-result.archive-pages #pr_form_subbmit').focusout(function() {
    $(this).parent().removeClass('searchResultInputFocused');
  })

  //Archive Pages On Focus Filter Input Outline
  // $('.archive-pages .select2-selection--multiple').focusin(function(){
  //   $(this).css('outline','1px auto');
  // })

  // $('.archive-pages .select2-selection--multiple').focusout(function(){
  //   $(this).css('outline','none');
  // })

  $('.archive-pages .react-select__value-container > input').focusin(function(){
    $(this).parent().parent('.react-select__control').css('outline','1px auto');
  })

  $('.archive-pages .react-select__value-container > input').focusout(function(){
    $(this).parent().parent('.react-select__control').css('outline','none');
  })

  // $('.section--searchPage .select2-selection--multiple').focusin(function(){
  //   $(this).parent('.select2-selection--multiple').css('outline','1px auto');
  // })
  // $('.section--searchPage .select2-selection--multiple').focusout(function(){
  //   $(this).parent('.select2-selection--multiple').css('outline','none');
  // })

  //  $('.section--searchPage .select2-selection--multiple').focusin(function(){
  //   $(this).parent('.select2-selection--multiple').css('outline','1px auto');
  // })

  // $('.section--searchPage .select2-selection--multiple').focusout(function(){
  //   $(this).parent('.select2-selection--multiple').css('outline','none');
  // })


  //R&I Form Error Msg Read
  $(this).find('#linkToForm.wrapperAutoCloudSection form .mf-file-upload').attr('aria-live','polite');

  //Date From and Date To Filter - Prevent Opening Keyboard in mobile devices
  $('#pr_datefrom').attr('readonly','readonly');
  $('#pr_dateto').attr('readonly','readonly');

  //Datepicker Accessibility
  if($('#ui-datepicker-div').html() !== '' && $('#ui-datepicker-div').is(':visible')) {
    $(document).keyup(function(e){
      if(e.which === 40) {
        $('#ui-datepicker-div').attr('tabindex','0').focus();
      }
    })
  }

  const dayNames = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
    "Sunday"];
  const monthsNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  $('.ui-datepicker-header .ui-datepicker-prev, .ui-datepicker-header .ui-datepicker-next').attr('href','javascript:void(0)');

  $('.ui-datepicker-calendar tbody tr td').each(function( index ) {
    let dateDay = dayNames[$(this).index()];
    let dateMonth = monthsNames[$(this).attr('data-month')];
    let dateYear = $(this).attr('data-year');
    let date = $(this).find('a').html();
    let fullDate = date + '' + dateMonth + '' + dateYear + '' + dateDay;
    $(this).find('a').attr('aria-label', fullDate);
  });

  $('.ui-datepicker-month option').each(function() {
    $(this).attr('aria-label',monthsNames[$(this).index()]);
  })

  $('.ui-datepicker-header > a.ui-state-disabled').attr('tabindex','-1');
  if(localStorage.getItem('prevDateFocusItem')) {
    $('.'+ localStorage.getItem('prevDateFocusItem')).focus();
  }

  //Intro Para Block Followed By Article Content Block Then Padding Bottom Adjust
  if($('.wp-block-cg-blocks-intro-para+.section--article-content').length !== 0) {
    $('.wp-block-cg-blocks-intro-para').css('padding-bottom','0');
  }

});

jQuery('.country-link-chips a').each(function() {
    var currentElement = $(this);
    var currentElementLength = currentElement.html().length;
    if(currentElementLength > 2){
      currentElement.addClass('lg-c-nm');
    } else {
      currentElement.addClass('sm-c-nm');
    }
});

// Location map adjusts height in case of browser zooming

const updatePixelRatio = () => {
  let pr = window.devicePixelRatio;
  //let prString = (pr * 100).toFixed(0);
  //console.log(`${prString}% (${pr.toFixed(2)})`);
  if(pr > 1.5) {
    $('.section--locations-map #map').css('max-height', '100vh');
  } else {
    $('.section--locations-map #map').css('max-height', 'calc(100vh - 136px)');
  }
  matchMedia(`(resolution: ${pr}dppx)`).addEventListener("change", updatePixelRatio, { once: true })
}

updatePixelRatio();

$(document).ready(function() {
  $("a[target='_blank']").each(function() {
    let rel_attr = $(this).attr('rel');
    if( rel_attr === undefined || rel_attr === "" ) {
      $(this).attr("rel", "noopener noreferrer");
    }
  });
});

//$(document).ready(() => {

  //  $('.content').children('p,h1,h2,h3,h4,h5,figure,img,ul').each(function() {
	//  $(this).wrap('<section class="wp-block-cg-blocks-group section section--article-content wp-default-elements"><div class="article-main-content"><div class="container"><div class="article-text article-quote-text"></div></div></div></section>');
	//  $(this).show();

  //  });

//	$('.content').children('.blog-page').children().children('p,h1,h2,h3,h4,h5,figure,img,ul').each(function() {
//	  $(this).wrap('<section class="wp-block-cg-blocks-group section section--article-content wp-default-elements"><div class="article-main-content"><div class="container"><div class="article-text article-quote-text"></div></div></div></section>');
//	  $(this).show();
 //   });

//});

// Projects page listing
$(document).ready(function() {

  const loadProjectResult = function() {
    let pathName = common_utility_var.pathName !== undefined && common_utility_var.pathName !== null && common_utility_var.pathName !== '' ? '/' + common_utility_var.pathName : '';
    let ajaxUrl = pathName + '/wp-json/macs/v1/project_search_results?';
    let project_slug = $("#project_slug").val();
    let project_page = $("#project_page").val();

    ajaxUrl += "project_category=" + project_slug;

    if(project_page) {
      ajaxUrl += "&page=" + project_page;
    }

    $.ajax({
      type: 'GET',
      url: ajaxUrl,
      success: function (response, textStatus, jqXHR) {
        $('.filters-content').attr( 'data-page', response.page )
        $('.filters-content').attr( 'data-page-max', response.total_pages )
        $('.filters-content').append(response.resulthtml);
        if ( !response.resulthtml) {
          $('.filters-more').hide();
        } else {
          let currentPage = parseInt($('.filters-content').attr( 'data-page' ), 10 );
          let maxPages    = parseInt( $('.filters-content').attr( 'data-page-max' ), 10 );

          if ( maxPages > currentPage ) {
            $('.filters-more').show();
          } else {
            $('.filters-more').hide();
          }
        }
      }
    });
  }
  $('#project_filters_more').on('click', function(e) {
    e.preventDefault();
    let project_page = $("#project_page").val();
    let next_page = parseInt(project_page)+1;
    $("#project_page").val(next_page);

    loadProjectResult();
  });

  if( $(".archive-Project-Page").length > 0 ) {
    loadProjectResult();
  }
})

/**
 * This script handles the dynamic loading of search results when the "Load More" button is clicked on the search page.
 * 
 * Key functionality:
 * 1. Tracks the number of results currently displayed and updates the "Show next" counter accordingly.
 * 2. Makes an AJAX request to load additional posts when "Load More" is clicked, ensuring no duplicates by correctly handling pagination with the 'paged' parameter.
 * 3. Dynamically appends new posts to the existing list of results and hides the "Load More" button once all posts are displayed.
 * 4. Properly formats post data (e.g., date, excerpt) for display in the search results.
 * 
 * Enhancements:
 * - Ensures a seamless user experience by continuously loading new results without reloading the page.
 * - Maintains efficient pagination to prevent redundant data from being loaded or displayed.
 */
$(document).ready(function() {
  const searchPageConfig = window.searchPageConfig;

  // This config is only present on search pages where load-more is rendered.
  if (!searchPageConfig) {
    return;
  }

  const postsPerPage = searchPageConfig.postsPerPage;
  const sortdate = searchPageConfig.sortdate;
  let paged = 2;  // Starts at page 2 since page 1 is already loaded
  let totalResults = searchPageConfig.totalResults;
  let currentResultsCount = $('.search_load_more .box').length;
  let searchTerm = $('#input_search_page').val(); // Get search term from the input field

  function updateShowNextText() {
      $('.showNextText').html(`<h5>Show next (${currentResultsCount}/${totalResults})</h5>`);
  }

  function loadMoreResults() {
    // Make sure we are passing all required parameters (paged, posts_per_page, s)
    const dataParameters = {
        s: searchTerm,  // Get the search term from the input field or page config
        paged: paged,  // Current page we are loading
        SortByDate: sortdate,  // Sort order
        posts_per_page: postsPerPage,  // Posts per page
    };

    $.ajax({
        url: `${window.location.origin}/wp-json/wp/v2/load-more/`,  // Dynamically construct the REST API endpoint
        type: 'GET',
        data: dataParameters,
        success: function(response) {
          let html = '';
          const options = { year: 'numeric', month: 'long', day: 'numeric' };
          
          if (response.length > 0) {
              response.forEach(post => {
                  var date = new Date(post.date); 
                  const formattedDate = date.toLocaleDateString('en-US', options);
                  
                  html += `<div class="box">
                              <h5 class="box-tag">${post.post_type}</h5>
                              <a href="${post.link}" class="box-title"><h4>${post.title}</h4></a>
                              <span class="box-tag2">${post.excerpt}</span>
                              <span class="box-date">${formattedDate}</span>
                          </div>`;
              });
              $('.search_load_more').append(html);
              paged++;  // Increment the paged value after loading more results
              currentResultsCount += response.length;
              updateShowNextText();
  
              if (currentResultsCount >= totalResults) {
                  $('.header-search-results-bottom').hide();
              }
          } else {
              $('.header-search-results-bottom').hide();
          }
      },
      error: function (xhr, status, error) {
          console.error('Failed to load more results:', error);
          console.error('Status:', status);
          console.error('XHR:', xhr);
      }
  });
  }

  // Event handler for the Load More button
  $('#search_result_load_more_false').on('click', function() {
      loadMoreResults();
  });

  updateShowNextText();
});
